export default {
  dataModel: {
    types: ['cdlt:Registration'],
    fieldsMapping: {
      title: 'pair:label'
    }
  },
  
  translations: {
    fr: {
      name: 'Réservation |||| Réservations',
      fields: {
        
      }
    },
    en: {
      name: 'Booking |||| Bookings',
      fields: {
        
      }
    }
    
  }
};
